import { render, staticRenderFns } from "./addImages.vue?vue&type=template&id=0a22fcd0"
import script from "./addImages.vue?vue&type=script&lang=js"
export * from "./addImages.vue?vue&type=script&lang=js"
import style0 from "./addImages.vue?vue&type=style&index=0&id=0a22fcd0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports